import type { Components } from '@mui/material/styles';

export default function MUISnackbarContent(): Components['MuiSnackbarContent'] {
  return {};
}
